export const fromUtc = (date: string | Date | undefined): Date => {
  if (!date) return new Date()

  if (date instanceof Date) return date

  // Helios dates are in UTC
  if (!date.endsWith('Z')) {
    date += 'Z'
  }

  return new Date(date)
}

/**
 * Returns the current date in UTC
 */
export const toUtc = (date: Date): string => {
  return date.toISOString()
}

/**
 * Returns the current date in UTC
 */
export const nowUtc = (): string => {
  return toUtc(new Date())
}

export const toUtcTime = (date: string): string => {
  const parsedDate = new Date(date)
  const hours = (parsedDate.getUTCHours() + '').padStart(2, '0')
  const minutes = (parsedDate.getUTCMinutes() + '').padStart(2, '0')
  const seconds = (parsedDate.getUTCSeconds() + '').padStart(2, '0')
  return `${hours}:${minutes}:${seconds}`
}

/**
 * Check this out if you wonder why I'm doing it this way:
 *
 * https://stackoverflow.com/questions/7556591/is-the-javascript-date-object-always-one-day-off
 */
export const getZeroUtcDate = (date: string): string => {
  const parsedDate = new Date(date)
  const year = parsedDate.getUTCFullYear()
  const month = (parsedDate.getUTCMonth() + 1 + '').padStart(2, '0')
  const day = (parsedDate.getUTCDate() + '').padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Same thing as above, but returns a Date object
 */
export const getZeroUtcDateAsDate = (date: string): Date => {
  const parsedDate = new Date(date)
  const year = parsedDate.getUTCFullYear()
  const month = parsedDate.getUTCMonth()
  const day = parsedDate.getUTCDate()
  return new Date(year, month, day)
}
